import * as React from "react";
import { Suspense, lazy } from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";

const $ = require("jquery");
import * as bootstrap from "bootstrap";
import Splide from '@splidejs/splide';


import LoadingIndicator from "./shared/LoadingIndicator";
const CommunityEvents = lazy(() => import("./pages/CommunityEvents"));
const FormComponent = lazy(() => import("./formBuilder/formComponent"));
const ResourcesList = lazy(() => import("./pages/ResourcesList"));
const SiteSearch = lazy(() => import("./pages/SiteSearch"));
//const accordionWidget = lazy(() => );


import { siteInit } from "./site/index";

const globalAny: any = global;

const CenteredLoadingIndicator = () => {
    return <div className="text-center"><LoadingIndicator /></div>
}

globalAny.React = React;
globalAny.ReactDOM = ReactDOM;
globalAny.ReactDOMClient = ReactDOMClient;
globalAny.Splide = Splide;

globalAny.CommunityEvents = (props: any) => (<Suspense fallback={<CenteredLoadingIndicator />}><CommunityEvents {...props} /></Suspense>);
globalAny.FormComponent = (props: any) => (<Suspense fallback={<CenteredLoadingIndicator />}><FormComponent {...props} /></Suspense>);
globalAny.ResourcesList = (props: any) => (<Suspense fallback={<CenteredLoadingIndicator />}><ResourcesList {...props} /></Suspense>);
globalAny.SiteSearch = (props: any) => (<Suspense fallback={<CenteredLoadingIndicator />}><SiteSearch {...props} /></Suspense>);


globalAny.boostrap = bootstrap;

siteInit();

// widgetAccordion
globalAny.widgetAccordion = () => {
    import("./site/widgetAccordion").then((module) => { module.default();});
} 

// todo is it used?? widgetFeaturedItemsCarousel
// widgetFeaturedItemsCarousel
globalAny.widgetFeaturedItemsCarousel = () => {
    import("./site/widgetFeaturedItemsCarousel").then((module) => { module.default(); });
} 

// widgetHeroBanner
globalAny.communitiesAutocomplete = () => {
    import("./site/communitiesAutocomplete").then((module) => { module.default(); });
}


export default global;